import i18n from '../../../i18n'
import { ServerResponseError } from 'src/errors'
import { ErrorCodes } from 'src/constants'

export default () => ({
  namespaced: true,
  getters: {
    describe: () => e => {
      if (e.response != null && e.response.status != null && e.response.data != null && e.response.data.error != null) {
        return {
          status: e.response.status,
          data: e.response.data,
          message: e.response.data.error
        }
      }
      return {
        message: e.message
      }
    }
  },
  actions: {
    // eslint-disable-next-line
    async describeError ({ commit }, { error }) {
      let errorMessage = null

      if (error instanceof ServerResponseError) {
        switch (error.errorCode) {
          case ErrorCodes.RATE_LIMIT:
            errorMessage = i18n.tc('rateLimitTitle', {value: error.errorCode})
            break
          case ErrorCodes.CAPTCHA_TOKEN_REQUIRED:
          case ErrorCodes.CAPTCHA_TOKEN_VALIDATION_FAIL:
          case ErrorCodes.CAPTCHA_TOKEN_VALIDATION_REQUEST_FAIL:
            errorMessage = i18n.tc('incorrectCaptchaTitle', {value: error.errorCode})
            break
          case ErrorCodes.UNAUTHORIZED:
            errorMessage = i18n.tc('wrongCredentialsTitle')
            break
          case ErrorCodes.ACCOUNT_SUSPENDED:
            errorMessage = i18n.tc('suspendedAccountTitle')
            break
          case ErrorCodes.UNCORRECT_FORGOT_CODE:
            errorMessage = i18n.tc('incorrectCodeTitle')
            break;
          case ErrorCodes.LOGIN_NOT_EXIST:
            errorMessage = i18n.tc('loginDoesntExistTitle')
            break;
          case ErrorCodes.LOGIN_ALREADY_EXIST:
            errorMessage = i18n.tc('loginAlreadyExistTitle')
            break;
          case ErrorCodes.AUTH_ERROR:
            errorMessage = i18n.tc('invalidCredentialsTitle')
            break;
          case ErrorCodes.VERIFICATION_NOT_CONFIGURED:
            errorMessage = i18n.tc('unconfiguredVerificationTitle')
            break;
          case ErrorCodes.VERIFICATION_INVALID_CODE:
            errorMessage = i18n.tc('invalidVerificationCodeTitle')
            break;
          default:
            errorMessage = i18n.tc('unknowErrorTitle', {value: error.errorCode})
        }
      } else {
        errorMessage = i18n.tc('unknowErrorTitle', {value: error.message})
      }

      return {
        errorMessage,
        error
      }
    },
  }
})
